"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TooltipModule = _interopRequireDefault(require("./Tooltip.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Enum for class direction values.
 *
 * @readonly
 * @enum {string}
 */


var TOOLTIP_DIRECTIONS = {
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  TOP: "top"
};
/**
 * Select the css class to suffix the main class which will apply direction specific styling
 *
 * @param {string} dir - Direction to render tooltip. Valid values are top, bottom, right, left. Default is top
 */

var directionClass = function directionClass() {
  var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TOOLTIP_DIRECTIONS.TOP;

  switch (dir) {
    case TOOLTIP_DIRECTIONS.LEFT:
      return _TooltipModule["default"].left;

    case TOOLTIP_DIRECTIONS.RIGHT:
      return _TooltipModule["default"].right;

    case TOOLTIP_DIRECTIONS.BOTTOM:
      return _TooltipModule["default"].bottom;

    default:
      return _TooltipModule["default"].top;
  }
};
/**
 * Renders a tooltip that only appears whne the child of this component is rendered
 *
 * @todo Implement the arrow rendering for a tooltip based on direction
 * @param {object} props
 * @param {object} props.children - The element that should have the tool tip rendered when hover
 * @param {string} props.direction - Direction to render tooltip. Valid values are top, bottom, right, left. Default is top
 * @param {string} props.message - Message to be displayed in the tooltip
 */


var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? TOOLTIP_DIRECTIONS.TOP : _ref$direction,
      message = _ref.message;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_TooltipModule["default"].tooltip, directionClass(direction)),
    "data-tooltip": message
  }, children);
};

exports.Tooltip = Tooltip;